import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Card,
  ContentSectionBlock,
  ButtonContainer,
  Button,
} from 'camino-react'

import AssociatedTicketContent from './AssociatedTicketContent'

import { cloudhelpPost } from 'Utilities/CloudHelp'
import BulkMessage from 'Components/Problems/BulkMessage'

const saveButtonText = (saveState) => {
  switch (saveState) {
    case 'saved':
      return 'Saved'
    case 'saving':
      return 'Saving...'
    default:
      return 'Save'
  }
}

const Pad = ({ children }) => (
  <div style={{ marginRight: '20px', paddingBottom: '20px', display: 'inline-block' }}>{children}</div>
)

class AssociatedTickets extends React.Component {
  constructor (props) {
    super(props)

    const { tickets, csi } = props

    this.state = {
      tickets,
      initialTickets: tickets,
      associatedTicketSelections: [],
      saveState: null,
      showModal: false,
      csi
    }

    this.addTicket = this.addTicket.bind(this)
    this.setTicket = this.setTicket.bind(this)
    this.removeTicket = this.removeTicket.bind(this)
    this.removeAssociatedTicketSelection = this.removeAssociatedTicketSelection.bind(this)
    this.saveAssociatedTickets = this.saveAssociatedTickets.bind(this)
  }

  setTicket (index, ticketId) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState

      const associatedTicketSelections = [...previous]
      associatedTicketSelections[index] = ticketId

      return { associatedTicketSelections }
    })
  }

  addTicket (ticketId) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState
      const associatedTicketSelections = [...previous, ticketId]

      return { associatedTicketSelections }
    })
  }

  removeTicket (index) {
    this.setState((prevState) => {
      const { tickets: previous } = prevState

      const tickets = [...previous]
      tickets.splice(index, 1)

      return { tickets }
    })
  }

  removeAssociatedTicketSelection (index) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState

      const associatedTicketSelections = [...previous]
      associatedTicketSelections.splice(index, 1)

      return { associatedTicketSelections }
    })
  }

  saveAssociatedTickets () {
    const { associatedTicketSelections, tickets } = this.state
    const { paths, setAlert } = this.props
    const { apiProblemAttachTicketsPath } = paths

    const existingTicketIds = _.map(tickets, ({ id }) => String(id))

    const postData = {
      ticket_ids: _.uniq([...existingTicketIds, ...associatedTicketSelections])
    }

    this.setState({ saveState: 'saving' })

    cloudhelpPost(apiProblemAttachTicketsPath, postData)
      .then((response) => {
        const { tickets: newTickets, flash } = response.data

        if (_.isObject(flash)) {
          setAlert(flash.message, flash.type)
        }

        this.setState({
          initialTickets: newTickets || [],
          tickets: newTickets || [],
          associatedTicketSelections: [],
          saveState: null
        })
      })
      .catch((error) => {
        const { errors } = error.response.data

        setAlert(errors.concat(' '), 'error')

        this.setState({ saveState: 'error' })
      })
  }

  render () {
    const {
      addTicket,
      setTicket,
      removeTicket,
      removeAssociatedTicketSelection
    } = this

    const {
      open,
      paths,
      problem,
      policy,
      hidden,
      setAlert,
      currentUser
    } = this.props

    const {
      saveState,
      tickets,
      initialTickets,
      associatedTicketSelections,
      showModal,
      csi
    } = this.state

    const canBulkMessage = policy('problem', 'bulkMessage')

    if (hidden) {
      return null
    }

    const showSave = (initialTickets !== tickets) || _.some(associatedTicketSelections)
    const showBulkMessage = canBulkMessage && _.some(tickets) && open

    return (
      <Card padding={false} allowOverflow>

        <ContentSectionBlock title="Associated Tickets">
          <AssociatedTicketContent
            policy={policy}
            addTicket={addTicket}
            setTicket={setTicket}
            removeTicket={removeTicket}
            removeAssociatedTicketSelection={removeAssociatedTicketSelection}
            associatedTicketSelections={associatedTicketSelections}
            tickets={tickets}
            paths={paths}
            currentUser={{ id: currentUser.id, name: currentUser.name }}
            csi={csi}
          />
        </ContentSectionBlock>

        {(_.some(tickets) || showSave) && (
          <div className="flex justify-end mt-4 mr-6">
            { showBulkMessage && (
              <Pad>
                <Button
                  disabled={showSave}
                  color="primary"
                  outline
                  onClick={() => { this.setState({ showModal: true }) }}
                >
                  Send bulk message
                </Button>
              </Pad>
            )}

            {showSave && (
              <Pad>
                <Button onClick={() => this.saveAssociatedTickets()}>
                  {saveButtonText(saveState)}
                </Button>
              </Pad>
            )}
          </div>
        )}

        <BulkMessage
          showModal={showModal}
          removeModal={(e) => { this.setState({ showModal: false }) }}
          paths={paths}
          problem={problem}
          setAlert={setAlert}
          tickets={tickets}
        />
      </Card>
    )
  }
}

AssociatedTickets.propTypes = {
  policy: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
  setAlert: PropTypes.func.isRequired,
  problem: PropTypes.object.isRequired,
  tickets: PropTypes.array,
  paths: PropTypes.shape({
    apiProblemsUnassignedTicketsPath: PropTypes.string
  }).isRequired
}

AssociatedTickets.defaultProps = {
  tickets: [],
  hidden: false
}

export default AssociatedTickets
